import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../../../../../../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SchoolService } from '../../../../../../services/school.service';
import { ClassService } from '../../../../../../services/class.service';
import { UserStatus, UserType } from '../../../../../../model/Const';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CoursewareService, Paragraph } from '../../../../../../services/courseware.service';
import { TwNoticeService } from '../../../../../../services/tw-notice.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { UploadImageWithPreviewComponent } from '../../../../../common/upload-image-with-preview/upload-image-with-preview.component';
import {
  UploadImageWithPreviewV2Component
} from '../../../../../common/upload-image-with-preview-v2/upload-image-with-preview-v2.component';
import { HWResourceService } from '../../../../../../services/huawei-resource.service';
import { WavePlayerV2Component } from '../../../../../common/wave-player-v2/wave-player-v2.component';
import * as _ from 'lodash';

@Component({
    selector: 'app-admin-resource-book-item-reading',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.scss'],
    standalone: false
})
export class AdminResourceBookItemReadingComponent implements OnInit, OnDestroy {
  user: any = null;
  constUserType = UserType;

  isLoading = false;
  form!: UntypedFormGroup;
  book_id = 0;
  currentPageIndex = 0;

  pages: any[] = [];
  factory_pages: any[] = [];
  // currentPageAudioParts: any[] = [];
  coursewareData: any = {};
  bookAudioUrl = '';
  bookAudioDuration = 0;
  currentPageAudioUrl = '';
  currentPageAudioDuration = 0;
  effectiveAudioUrl = '';
  private paragraphAudio = new Audio();
  private paragraphAudioTimer: any = null;
  private audioPointOverflowKeys = new Set<string>();
  playingParagraphKey = '';

  redrawRegionTrigger = new EventEmitter<any>();

  pageTpl = {
    image_area: [],
    text_area: []
  };

  bookAttrs: any = {};
  syllabusChildren = [];
  bisType = 'cartoon';
  imageScale = 1;


  @ViewChild('pageImage', {static: false})
  pageImage: UploadImageWithPreviewV2Component | undefined;
  protocol: string;
  host: string;
  bucket: string | undefined;


  constructor(private userService: UserService,
              private clsService: ClassService,
              private schoolService: SchoolService,
              private coursewareService: CoursewareService,
              private activatedRoute: ActivatedRoute ,
              private twNoticeService: TwNoticeService ,
              private router: Router ,
              private fb: UntypedFormBuilder,
              private nzMessageService: NzMessageService) {
    this.user = this.userService.getUserInfo();

    const u = new URL(window.location.href);
    this.protocol = u.protocol;
    this.host = HWResourceService.cdnHost;
    this.activatedRoute.title.subscribe({
      next: (title) => {
      }
    });

    // @ts-ignore
    this.bisType = this.router.url.split('?')[0].split('/').filter(Boolean)[3] ?? '';
    // this.activatedRoute.pathFromRoot[2].data.subscribe((data) => {
    //   this.bisType = data['bis_type'];
    //   console.log('bisType', this.bisType);
    // });
    // this.activatedRoute.queryParams.subscribe( (query: any) => {
    //   if (query.school && parseInt(query.school, 10) === query.school * 1) {
    //     this.school_id = parseInt(query.school, 10);
    //   }
    // });
    // this.activatedRoute.queryParams.subscribe( (query: any) => {
    //   if (query.page && parseInt(query.page, 10) === query.page * 1) {
    //     this.currentPageIndex = parseInt(query.page, 10);
    //   }
    // });


    this.activatedRoute.params.subscribe( params => {
      console.log('params', params);
      this.book_id = params['item_id'] || 0;
    });

  }


  onDecodeCallback = (comp: WavePlayerV2Component) => {
    return this.factory_pages[this.currentPageIndex]?.text_area?.paragraphs || [];
  }

  onRegionCreated = (region: any) => {
    const page = this.factory_pages[this.currentPageIndex];
    if (!page) {
      return;
    }
    if (!page.text_area) {
      page.text_area = { paragraphs: [] };
    }
    const paragraphs = page.text_area.paragraphs || [];
    const maxId = paragraphs.reduce((max: number, pa: any) => Math.max(max, pa.id || 0), 0);
    paragraphs.push({
      id: maxId + 1,
      text: '',
      cnTranslation: '',
      audioUrl: '',
      audioPoint: {
        start: this.roundAudioPoint(region.start),
        end: this.roundAudioPoint(region.end),
      },
      keyWords: [],
    });
    this.redrawRegionTrigger.emit();
  }

  onRegionUpdated = (region: any) => {
    const paragraphIdx = this.getParagraphIdxFromRegion(region);
    if (paragraphIdx < 0) {
      return;
    }
    const paragraph = this.factory_pages[this.currentPageIndex]?.text_area?.paragraphs?.[paragraphIdx];
    if (!paragraph) {
      return;
    }
    if (!paragraph.audioPoint) {
      paragraph.audioPoint = { start: 0, end: 0 };
    }
    paragraph.audioPoint.start = this.roundAudioPoint(region.start);
    paragraph.audioPoint.end = this.roundAudioPoint(region.end);
    this.normalizeParagraphAudioPoint(this.currentPageIndex, paragraphIdx);
  }

  onRegionRemoved = (region: any) => {
    const paragraphIdx = this.getParagraphIdxFromRegion(region);
    if (paragraphIdx < 0) {
      return;
    }
    this.deleteParagraph(null, paragraphIdx, false);
    this.redrawRegionTrigger.emit();
  }

  getParagraphIdxFromRegion(region: any): number {
    const id = region?.id;
    if (id && String(id).startsWith('p-')) {
      return parseInt(String(id).slice(2), 10);
    }
    return -1;
  }

  ngOnInit() {


    if (this.book_id) {
      this.isLoading = true;
      this.coursewareService.fetch(this.bisType, this.book_id).then((result) => {
        console.log('coursewareService.fetch', result);
        this.coursewareData = result;

        if (result?.data?.pages) {
          this.pages = [...result?.data.pages];
        }
        this.factory_pages = result?.data?.factory_pages || [];
        this.syncAudioState();
        // 不显示整书音频入口时（如教研），自动清除历史整书音频，避免与分页音频共存阻塞编辑
        this.discardHiddenBookAudio();
        this.normalizeAllAudioPoints();
        this.redrawRegionTrigger.emit();
        // if (!result?.data?.factory_pages) {
        //   if (!result.data) {
        //     result.data = {};
        //   }
        //   if (!result.data.dpe_page) {
        //     this.factory_pages = this.coursewareService.createDpePages(result);
        //     // this.factory_pages = factory_pages.filter(fp => fp.show);
        //   }
        // } else {
        //   this.factory_pages = result?.data?.factory_pages;
        // }
        this.isLoading = false;
      }).catch(err => {
        this.isLoading = false;
        this.nzMessageService.error(err.message || 'System Error');
      });
    }

  }

  pageIndexChange(index: number) {
    console.log('pageIndexChange', index);
    this.stopParagraphAudio();
    this.currentPageIndex = index;
    this.syncAudioState();
    this.redrawRegionTrigger.emit();
  }

  drop(event: CdkDragDrop<string[]>): void {
    if (event.previousIndex === event.currentIndex) {
      return;
    }
    moveItemInArray(this.pages, event.previousIndex, event.currentIndex);
    console.log('drop', this.pages);
  }
  onImageUploaded(evt: any) {
    const {width, height} = evt.file;
    console.log('onImageUploaded', {width, height}, evt);
    console.log('pageImage', this.pageImage?.previewElement);
    if (this.pageImage) {
      const rect = this.pageImage.previewElement?.nativeElement.getBoundingClientRect();
      console.log('rect', rect);
      const scaleX = rect.width / width;
      const scaleY = rect.height / height;
      this.imageScale = Math.min(scaleX, scaleY);
    }
    // this.pages[this.currentPageIndex].img = evt.url;
    // this.pages[this.currentPageIndex].img_width = width;
    // this.pages[this.currentPageIndex].img_height = height;
    _.set(this.pages, `[${this.currentPageIndex}].img`, evt.url );
    _.set(this.pages, `[${this.currentPageIndex}].img_width`, width );
    _.set(this.pages, `[${this.currentPageIndex}].img_height`, height );


    _.set(this.factory_pages[this.currentPageIndex], `image_area.images[0].imageUrl`, evt.url );
    _.set(this.factory_pages[this.currentPageIndex], `image_area.images[0].img_width`, width );
    _.set(this.factory_pages[this.currentPageIndex], `image_area.images[0].img_height`, height );
    // this.factory_pages[this.currentPageIndex].img =  evt.url;
    // this.factory_pages[this.currentPageIndex].img_width = width;
    // this.factory_pages[this.currentPageIndex].img_height = height;
  }
  onAudioUploadFailure(evt: any) {
    console.log('onAudioUploadFailure', evt);
  }
  onBookAudioUploadSuccess(evt: any) {
    if (this.hasAnyPageAudio()) {
      this.nzMessageService.warning('请先删除所有页码内音频，再上传整书音频');
      this.syncAudioState();
      return;
    }
    _.set(this.coursewareData, 'data.audio', evt.url);
    _.set(this.coursewareData, 'data.audio_duration', this.durationToSeconds(evt?.file?.duration));
    this.syncAudioState();
  }
  clearBookAudio(evt: any) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }
    _.set(this.coursewareData, 'data.audio', '');
    _.set(this.coursewareData, 'data.audio_duration', 0);
    this.syncAudioState();
  }
  onAudioUploadSuccess(evt: any) {
    console.log('onAudioUploadSuccess', evt);
    if (this.hasBookAudio()) {
      this.nzMessageService.warning('请先删除整书音频，再上传页码内音频');
      this.syncAudioState();
      return;
    }
    const {duration, name} = evt.file;
    const durationInSeconds = this.durationToSeconds(duration);
    if (this.pages[this.currentPageIndex]) {
      this.pages[this.currentPageIndex].audio = evt.url;
      this.pages[this.currentPageIndex].duration = durationInSeconds;
    }

    if (this.factory_pages[this.currentPageIndex]) {
      this.factory_pages[this.currentPageIndex].audio_url = evt.url;
      this.factory_pages[this.currentPageIndex].duration = durationInSeconds;
    }
    this.syncAudioState();
    this.normalizeAudioPointsForPage(this.currentPageIndex);

  }

  clearAudio($event: any) {
    console.log('clearAudio', $event);
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    if (this.pages[this.currentPageIndex]) {
      this.pages[this.currentPageIndex].audio = null;
    }
    if (this.factory_pages[this.currentPageIndex]) {
      this.factory_pages[this.currentPageIndex].audio_url = null;
      this.factory_pages[this.currentPageIndex].duration = 0;
    }

    this.syncAudioState();

  }
  removePage(): void {
    this.twNoticeService.confirm({
      nzContent: '删除此页?',
      nzOnOk: (e: any) => {
        this.pages.splice(this.currentPageIndex, 1);
        this.factory_pages.splice(this.currentPageIndex, 1);
        if (this.currentPageIndex >= this.factory_pages.length) {
          this.currentPageIndex = Math.max(this.factory_pages.length - 1, 0);
        }
        this.syncAudioState();
      }
    });

  }

  deleteParagraph(evt: any, index: number, shouldRedraw = true) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }
    const hotzoneIdx = this.factory_pages[this.currentPageIndex].image_area?.images[0]?.hotzones?.findIndex((hotzone: any) => {
      return hotzone.relatedParagraphId === this.factory_pages[this.currentPageIndex]?.text_area?.paragraphs[index]?.id;
    });
    if (hotzoneIdx >= 0) {
      this.factory_pages[this.currentPageIndex].image_area.images[0]?.hotzones.splice(hotzoneIdx, 1);
    }
    this.factory_pages[this.currentPageIndex].text_area?.paragraphs?.splice(index, 1);
    if (shouldRedraw) {
      this.redrawRegionTrigger.emit();
    }
  }
  addNewParagraph() {

    const idx = this.factory_pages[this.currentPageIndex]?.text_area?.paragraphs.reduce((maxId: number, pa: any) => {
      return Math.max(maxId, pa.id);
    }, 0) || 0;
    const lastIdx =  this.factory_pages[this.currentPageIndex]?.text_area?.paragraphs.length || 0;
    const audioPoint = this.getDefaultAudioPoint(lastIdx);

    _.set(this.factory_pages, `[${this.currentPageIndex}].show`, true);
    _.set(this.factory_pages, `[${this.currentPageIndex}].text_area.paragraphs[${lastIdx}]`, {
      id: idx + 1,
      text: '',
      cnTranslation: '',
      audioUrl: '',
      audioPoint,
      keyWords: [],
    });
    // this.factory_pages[this.currentPageIndex]?.text_area?.paragraphs?.push({
    //   id: idx + 1,
    //   text: '',
    //   cnTranslation: '',
    //   audioUrl: '',
    //   audioPoint: {
    //     start: 0,
    //     end: 0,
    //   },
    //   keyWords: [],
    // });
    this.redrawRegionTrigger.emit();
    // this.currentPageAudioParts = [...this.factory_pages[this.currentPageIndex].text_area.paragraphs];
  }

  highlightAudioPart(pageIndex: number, paragraphIdx: number) {
    // this.currentPageAudioParts = [...this.dpe_pages[pageIndex].text_area.paragraphs[paragraphIdx]];
  }
  resizeAudioPart($event: any, pageIndex: number, paragraphIdx: number, field?: 'start' | 'end') {
    console.log('resizeAudioPart', $event, pageIndex, paragraphIdx);
    this.normalizeParagraphAudioPoint(pageIndex, paragraphIdx, field, $event);
    this.redrawRegionTrigger.emit({pageIndex, paragraphIdx, value: $event});
  }

  hasBookAudio() {
    return Boolean(this.bookAudioUrl);
  }

  hasAnyPageAudio() {
    return this.factory_pages.some(page => Boolean(page?.audio_url));
  }

  hasAudioConflict() {
    return this.hasBookAudio() && this.hasAnyPageAudio();
  }

  // school_id > 1 为学校权限，显示整书音频；否则分页音频
  get showWholeBookAudioSection(): boolean {
    return this.user?.school_id > 1;
  }

  // 隐藏整书音频入口时丢弃整书音频（历史数据可能同时存在两类音频）
  discardHiddenBookAudio() {
    if (!this.showWholeBookAudioSection && this.hasBookAudio()) {
      this.clearBookAudio(null);
    }
  }

  syncAudioState() {
    const currentPage = this.factory_pages[this.currentPageIndex] || {};
    this.bookAudioUrl = this.coursewareData?.data?.audio || '';
    this.bookAudioDuration = this.durationToSeconds(this.coursewareData?.data?.audio_duration);
    this.currentPageAudioUrl = currentPage?.audio_url || '';
    this.currentPageAudioDuration = this.durationToSeconds(currentPage?.duration);
    this.effectiveAudioUrl = this.currentPageAudioUrl || this.bookAudioUrl;
  }

  durationToSeconds(duration: any) {
    const value = Number(duration) || 0;
    if (!value) {
      return 0;
    }
    return value > 1000 ? value / 1000 : value;
  }

  audioPointToSeconds(value: any, maxDuration = 0) {
    const point = Number(value) || 0;
    if (maxDuration && point >= 1000 && point > maxDuration && point / 1000 <= maxDuration) {
      return point / 1000;
    }
    return point;
  }

  getEffectiveAudioDuration(pageIndex = this.currentPageIndex) {
    const page = this.factory_pages[pageIndex] || {};
    const pageDuration = this.durationToSeconds(page?.duration);
    if (page?.audio_url) {
      return pageDuration;
    }
    return this.bookAudioDuration;
  }

  getAudioPointInputMax(pageIndex: number) {
    return this.getEffectiveAudioDuration(pageIndex) || 99999;
  }

  normalizeAllAudioPoints() {
    this.factory_pages.forEach((page, pageIndex) => {
      this.normalizeAudioPointsForPage(pageIndex);
    });
  }

  normalizeAudioPointsForPage(pageIndex: number) {
    const paragraphs = this.factory_pages[pageIndex]?.text_area?.paragraphs || [];
    paragraphs.forEach((paragraph: any, paragraphIdx: number) => {
      this.normalizeParagraphAudioPoint(pageIndex, paragraphIdx);
    });
  }

  normalizeParagraphAudioPoint(pageIndex: number, paragraphIdx: number, field?: 'start' | 'end', inputValue?: any) {
    const paragraph = this.factory_pages[pageIndex]?.text_area?.paragraphs?.[paragraphIdx];
    if (!paragraph) {
      return;
    }

    if (!paragraph.audioPoint) {
      paragraph.audioPoint = {start: 0, end: 0};
    }

    const maxDuration = this.getEffectiveAudioDuration(pageIndex);
    const fieldValue = Number(inputValue) || 0;
    if (field && maxDuration) {
      const overflowKey = this.getAudioPointOverflowKey(pageIndex, paragraphIdx, field);
      if (fieldValue > maxDuration) {
        const fieldLabel = field === 'start' ? '开始时间' : '结束时间';
        this.audioPointOverflowKeys.add(overflowKey);
        this.nzMessageService.warning(`${fieldLabel}不能超过音频时长`);
      } else {
        this.audioPointOverflowKeys.delete(overflowKey);
      }
    }
    const start = this.audioPointToSeconds(paragraph.audioPoint.start, maxDuration);
    const end = this.audioPointToSeconds(paragraph.audioPoint.end, maxDuration);
    paragraph.audioPoint.start = this.roundAudioPoint(this.clampAudioPoint(start, maxDuration));
    paragraph.audioPoint.end = this.roundAudioPoint(this.clampAudioPoint(end, maxDuration));

    if (paragraph.audioPoint.end !== 0 && paragraph.audioPoint.end < paragraph.audioPoint.start) {
      paragraph.audioPoint.end = paragraph.audioPoint.start;
    }
  }

  getDefaultAudioPoint(lastIdx: number) {
    const page = this.factory_pages[this.currentPageIndex] || {};
    const paragraphs = page?.text_area?.paragraphs || [];
    const maxDuration = this.getEffectiveAudioDuration();

    if (page?.audio_url) {
      if (lastIdx === 0) {
        return {start: 0, end: 0};
      }
      const lastEnd = this.audioPointToSeconds(paragraphs[lastIdx - 1]?.audioPoint?.end, maxDuration);
      return this.buildAudioPoint(lastEnd, maxDuration);
    }

    if (this.bookAudioUrl) {
      const previousEnd = this.getPreviousPageLastParagraphEnd(maxDuration);
      return this.buildAudioPoint(previousEnd, maxDuration);
    }

    return {start: 0, end: 0};
  }

  getPreviousPageLastParagraphEnd(maxDuration: number) {
    for (let i = this.currentPageIndex - 1; i >= 0; i--) {
      const paragraphs = this.factory_pages[i]?.text_area?.paragraphs || [];
      if (paragraphs.length > 0) {
        return this.audioPointToSeconds(paragraphs[paragraphs.length - 1]?.audioPoint?.end, maxDuration);
      }
    }
    return 0;
  }

  buildAudioPoint(start: number, maxDuration: number) {
    const safeStart = this.clampAudioPoint(start, maxDuration);
    return {
      start: this.roundAudioPoint(safeStart),
      end: this.roundAudioPoint(safeStart),
    };
  }

  clampAudioPoint(value: number, maxDuration: number) {
    const safeValue = Math.max(Number(value) || 0, 0);
    if (!maxDuration) {
      return safeValue;
    }
    return Math.min(safeValue, maxDuration);
  }

  roundAudioPoint(value: number) {
    return Math.round(value * 100) / 100;
  }

  getAudioPointOverflowKey(pageIndex: number, paragraphIdx: number, field: 'start' | 'end') {
    return `${pageIndex}:${paragraphIdx}:${field}`;
  }

  getParagraphPlayKey(pageIndex: number, paragraphIdx: number) {
    return `${pageIndex}:${paragraphIdx}`;
  }

  isParagraphPlaying(pageIndex: number, paragraphIdx: number) {
    return this.playingParagraphKey === this.getParagraphPlayKey(pageIndex, paragraphIdx);
  }

  getPlayableAudioUrl(audioUrl: string) {
    return HWResourceService.resolveMediaUrl(audioUrl);
  }

  playParagraphAudio(paragraph: any, pageIndex: number) {
    const page = this.factory_pages[pageIndex] || {};
    const paragraphIdx = page?.text_area?.paragraphs?.indexOf(paragraph) ?? -1;
    if (paragraphIdx >= 0 && this.isParagraphPlaying(pageIndex, paragraphIdx)) {
      this.stopParagraphAudio();
      return;
    }
    const audioUrl = page?.audio_url || this.bookAudioUrl;
    if (!audioUrl) {
      this.nzMessageService.warning('请先上传音频');
      return;
    }

    const maxDuration = this.getEffectiveAudioDuration(pageIndex);
    const start = this.audioPointToSeconds(paragraph?.audioPoint?.start, maxDuration);
    const end = this.audioPointToSeconds(paragraph?.audioPoint?.end, maxDuration);
    if (paragraphIdx >= 0 && this.audioPointOverflowKeys.has(this.getAudioPointOverflowKey(pageIndex, paragraphIdx, 'end'))) {
      this.nzMessageService.warning('结束时间不能超过音频时长');
      return;
    }
    if (paragraphIdx >= 0 && this.audioPointOverflowKeys.has(this.getAudioPointOverflowKey(pageIndex, paragraphIdx, 'start'))) {
      this.nzMessageService.warning('开始时间不能超过音频时长');
      return;
    }
    if (!(start === 0 && end === 0) && end <= start) {
      this.nzMessageService.warning('结束时间必须大于开始时间');
      return;
    }
    this.stopParagraphAudio();
    if (paragraphIdx >= 0) {
      this.playingParagraphKey = this.getParagraphPlayKey(pageIndex, paragraphIdx);
    }
    this.paragraphAudio.onended = () => {
      this.stopParagraphAudio();
    };
    this.paragraphAudio.src = this.getPlayableAudioUrl(audioUrl);
    this.paragraphAudio.currentTime = start;
    this.paragraphAudio.play().catch(err => {
      this.playingParagraphKey = '';
      this.nzMessageService.error(err?.message || '音频播放失败');
    });

    if (!(start === 0 && end === 0) && end > start) {
      this.paragraphAudioTimer = setTimeout(() => {
        this.stopParagraphAudio();
      }, (end - start) * 1000);
    }
  }

  stopParagraphAudio() {
    if (this.paragraphAudioTimer) {
      clearTimeout(this.paragraphAudioTimer);
      this.paragraphAudioTimer = null;
    }
    this.paragraphAudio.pause();
    this.paragraphAudio.onended = null;
    this.playingParagraphKey = '';
  }

  checkPageConfig () {
    this.discardHiddenBookAudio();
    let msg = '';
    if (this.hasAudioConflict()) {
      this.nzMessageService.error('整书音频和页码内音频不能同时存在，请删除其中一类');
      return this.currentPageIndex;
    }
    const idx = this.factory_pages.findIndex((p, i) => {
       if (Boolean(!p?.image_area?.images[0]?.imageUrl)) {
         msg = `please upload image in page ${i + 1}`;
         return true;
       }
      if (this.bisType !== 'book') {
        // cartoon 等非 book 资源：按原有逻辑检查文本和音频
        if (p.show) {
          const allPageHasText = p?.text_area?.paragraphs?.every(( (pa: Paragraph) => {
            return pa.text && pa.text.trim();
          }));
          if (Boolean(!allPageHasText)) {
            msg = `please fill text in page ${i + 1}`;
            return true;
          }
        }

        if (!this.bookAudioUrl && Boolean(!p.audio_url)) {
           msg = `please upload audio in page ${i + 1}`;
           return true;
         }
      }

       return false;
    });
    if (idx >= 0) {
      this.nzMessageService.error(msg);
      return idx;
    }

    // book + 学校权限 → 整书音频；book + 非学校权限 → 分页音频
    if (this.showWholeBookAudioSection) {
      if (!this.bookAudioUrl) {
        this.nzMessageService.error('请上传整书音频');
        return this.currentPageIndex;
      }
    } else if (this.bisType === 'book') {
      for (let i = 0; i < this.factory_pages.length; i++) {
        const page = this.factory_pages[i];
        if (page.show !== false && !page.audio_url) {
          this.nzMessageService.error(`请在页码 ${i + 1} 上传分页音频`);
          return i;
        }
      }
    }

    return -1;
  }

  addNewPage() {
    console.log('addNewPage');
    const idx = this.checkPageConfig();
    if (idx >= 0) {
      this.currentPageIndex = idx;
      this.syncAudioState();
      return;
    }
    this.pages.push({});
    // this.factory_pages.push(JSON.parse(JSON.stringify(this.pageTpl)));
    this.factory_pages.push({});
  }


  saveCoursewarePage() {
    if (this.isLoading) {
      return;
    }
    this.discardHiddenBookAudio();
    this.normalizeAllAudioPoints();
    const idx = this.checkPageConfig();
    if (idx >= 0) {
      this.currentPageIndex = idx;
      this.syncAudioState();
      return;
    }

    // const factory_pages = this.coursewareService.createDpePages(this.book_id, this.pages);
    const newData = {
      id: this.coursewareData.id,
      data: {
        ...this.coursewareData.data,
        audio: this.bookAudioUrl,
        audio_duration: this.bookAudioDuration,
        duration: this.bookAudioDuration,
        factory_pages: this.factory_pages
      }
    };
    console.log('factory_pages', newData);
    // delete newData.created_date;
    // delete newData.updated_date;
    // this.coursewareService.save({id: this.book_id, data: {pages: this.pages}}).then((result) => {
    this.coursewareService.save(this.bisType, newData).then((result) => {
      this.isLoading = false;
      this.twNoticeService.success({nzContent: '儲存成功'});
      // const modal = this.twNoticeService.success({nzContent: '新增成功'})
      // modal.afterClose.subscribe(() => {
      //   this.router.navigate([`/admin/v3/resource/${this.bisType}/manage`]);
      // });
    }).catch(err => {
      this.isLoading = false;
      this.nzMessageService.error(err.message || 'System Error');
    });
  }


  submitForm = ($event: any, value: any) => {
    if ($event) {
      $event.preventDefault();
    }
    for (const key in this.form.controls) {
      this.form.controls[ key ].markAsDirty();
      this.form.controls[ key ].updateValueAndValidity();
    }
    if (this.isLoading) {
      return;
    }
    console.log('submitForm', $event, value);
    this.isLoading = true;
    this.coursewareService.save(this.bisType, value).then((result) => {
      this.isLoading = false;
      const modal = this.twNoticeService.success({nzContent: '新增成功'});
      modal.afterClose.subscribe(() => {
        this.router.navigate([`/admin/v3/resource/${this.bisType}/courseware`]);
      });
    }).catch(err => {
      this.isLoading = false;
      this.nzMessageService.error(err.message || 'System Error');
    });
  }

  resetForm(e: MouseEvent): void {
    e.preventDefault();
    this.form.reset();
    for (const key in this.form.controls) {
      this.form.controls[ key ].markAsPristine();
      this.form.controls[ key ].updateValueAndValidity();
    }
  }

  ngOnDestroy() {
    this.stopParagraphAudio();
  }

  translate(evt: any, index: number, comp: any) {
    console.log('translate', evt, comp);
    // @ts-ignore
    window.aaa = comp;
    comp.nzLoading = true;
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);
    fetch('https://api.cognitive.microsofttranslator.com/translate?api-version=3.0&from=en&to=zh-Hans', {
      method: 'POST',
      signal: controller.signal,
      headers: {
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': 'b61e900d6c7d483c9b3666430c887835',
        'Ocp-Apim-Subscription-Region': 'eastasia',
      },
      body: JSON.stringify([
       {
         // @ts-ignore
          'Text': this.factory_pages[this.currentPageIndex].text_area.paragraphs[index].text
        }
      ])
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        // @ts-ignore
        this.factory_pages[this.currentPageIndex].text_area.paragraphs[index].cnTranslation = data[0].translations[0].text;
        comp.nzLoading = false;
        clearTimeout(timeoutId);
      })
      .catch(error => {
        clearTimeout(timeoutId);
        comp.nzLoading = false;
        console.error('Error:', error);
      });
  }

}
